import React, { PureComponent } from 'react';
import { base16Themes } from 'react-base16-styling';
import { ActionCreators, } from '@redux-devtools/core';
import debounce from 'lodash.debounce';
import { updateScrollTop, startConsecutiveToggle, } from './actions.js';
import reducer from './reducers.js';
import LogMonitorButtonBar from './LogMonitorButtonBar.js';
import LogMonitorEntryList from './LogMonitorEntryList.js';
const { toggleAction, setActionsActive } = ActionCreators;
const styles = {
    container: {
        fontFamily: 'monaco, Consolas, Lucida Console, monospace',
        position: 'relative',
        overflowY: 'hidden',
        width: '100%',
        height: '100%',
        minWidth: 300,
        direction: 'ltr',
    },
    elements: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
    },
};
class LogMonitor extends PureComponent {
    constructor() {
        super(...arguments);
        this.updateScrollTop = debounce(() => {
            const node = this.node;
            this.props.dispatch(updateScrollTop(node ? node.scrollTop : 0));
        }, 500);
        this.handleToggleAction = (id) => {
            this.props.dispatch(toggleAction(id));
        };
        this.handleToggleConsecutiveAction = (id) => {
            const { monitorState, actionsById } = this.props;
            const { consecutiveToggleStartId } = monitorState;
            if (consecutiveToggleStartId && actionsById[consecutiveToggleStartId]) {
                const { skippedActionIds } = this.props;
                const start = Math.min(consecutiveToggleStartId, id);
                const end = Math.max(consecutiveToggleStartId, id);
                const active = skippedActionIds.includes(consecutiveToggleStartId);
                this.props.dispatch(setActionsActive(start, end + 1, active));
                this.props.dispatch(startConsecutiveToggle(null));
            }
            else if (id > 0) {
                this.props.dispatch(startConsecutiveToggle(id));
            }
        };
        this.getRef = (node) => {
            this.node = node;
        };
    }
    scroll() {
        const node = this.node;
        if (!node) {
            return;
        }
        if (this.scrollDown) {
            const { offsetHeight, scrollHeight } = node;
            node.scrollTop = scrollHeight - offsetHeight;
            this.scrollDown = false;
        }
    }
    componentDidMount() {
        const node = this.node;
        if (!node || !this.props.monitorState) {
            return;
        }
        if (this.props.preserveScrollTop) {
            node.scrollTop = this.props.monitorState.initialScrollTop;
            node.addEventListener('scroll', this.updateScrollTop);
        }
        else {
            this.scrollDown = true;
            this.scroll();
        }
    }
    componentWillUnmount() {
        const node = this.node;
        if (node && this.props.preserveScrollTop) {
            node.removeEventListener('scroll', this.updateScrollTop);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const node = this.node;
        if (!node) {
            this.scrollDown = true;
        }
        else if (this.props.stagedActionIds.length < nextProps.stagedActionIds.length) {
            const { scrollTop, offsetHeight, scrollHeight } = node;
            this.scrollDown =
                Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
        }
        else {
            this.scrollDown = false;
        }
    }
    componentDidUpdate() {
        this.scroll();
    }
    getTheme() {
        const { theme } = this.props;
        if (typeof theme !== 'string') {
            return theme;
        }
        if (typeof base16Themes[theme] !== 'undefined') {
            return base16Themes[theme];
        }
        // eslint-disable-next-line no-console
        console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
        return base16Themes.nicinabox;
    }
    render() {
        const theme = this.getTheme();
        const { consecutiveToggleStartId } = this.props.monitorState;
        const { dispatch, actionsById, skippedActionIds, stagedActionIds, computedStates, currentStateIndex, select, expandActionRoot, expandStateRoot, markStateDiff, } = this.props;
        const entryListProps = {
            theme,
            actionsById,
            skippedActionIds,
            stagedActionIds,
            computedStates,
            currentStateIndex,
            consecutiveToggleStartId,
            select,
            expandActionRoot,
            expandStateRoot,
            markStateDiff,
            onActionClick: this.handleToggleAction,
            onActionShiftClick: this.handleToggleConsecutiveAction,
        };
        return (React.createElement("div", { style: { ...styles.container, backgroundColor: theme.base00 } },
            !this.props.hideMainButtons && (React.createElement(LogMonitorButtonBar, { theme: theme, dispatch: dispatch, hasStates: computedStates.length > 1, hasSkippedActions: skippedActionIds.length > 0 })),
            React.createElement("div", { style: this.props.hideMainButtons
                    ? styles.elements
                    : { ...styles.elements, top: 30 }, ref: this.getRef },
                React.createElement(LogMonitorEntryList, { ...entryListProps }))));
    }
}
LogMonitor.update = reducer;
LogMonitor.defaultProps = {
    select: (state) => state,
    theme: 'nicinabox',
    preserveScrollTop: true,
    expandActionRoot: true,
    expandStateRoot: true,
    markStateDiff: false,
};
export default LogMonitor;
